import { useTranslation } from "react-i18next";
import { Field } from "../../components/neu/Field";
import { EmployeePersonalFields } from "../admin/EmployeePersonalFields";

// حقول ملف الموظف: الجوال + الحقول الشخصية والمستندات + الآيبان.
export const ProfileFields = ({ phone, setPhone, personal, setPersonal, countries, rule, errors }) => {
  const { t } = useTranslation();
  return (
    <div className="grid gap-5 sm:grid-cols-2">
      <Field label={t("employees.phone")} testId="profile-phone" value={phone} onChange={setPhone} inputMode="tel" />      <Field
        label={t("personal.iban")}
        testId="profile-iban"
        value={personal.iban || ""}
        onChange={(v) => setPersonal("iban", v.toUpperCase().replace(/\s/g, ""))}
      />
      <EmployeePersonalFields
        personal={personal}
        setPersonal={setPersonal}
        countries={countries}
        rule={rule}
        errors={errors}
      />
    </div>
  );
};
